import { type FieldType, type ISubJobSearchResult } from '@/interfaces'

export class SubJobSearchResult implements ISubJobSearchResult {
	[key: string]: FieldType
	id: number
	subjobId: number
	subjobNumber: string
	subjobName: string
	salesTeam: number

	constructor({ subjobId, subjobNumber, subjobName, salesTeam }: ISubJobSearchResult) {
		this.id = subjobId // Use subjobId as the main ID for compatibility
		this.subjobId = subjobId
		this.subjobNumber = subjobNumber
		this.subjobName = subjobName
		this.salesTeam = salesTeam
	}

	// Alias for compatibility with ISubJobIndex usage
	get name(): string {
		return this.subjobName
	}

	// Additional getters for compatibility if needed
	get clientName(): string {
		return '' // Not available in search results
	}

	get jobNumber(): string {
		return '' // Not available in search results
	}

	get subjobType(): number {
		return 0 // Not available in search results
	}
}
